var fn = function( obj ){
var __t,__p='';
__p+='varying vec3 vView;\nvarying vec2 vTexcoord;\n\nuniform sampler2D tSkyColor;\nuniform float uAlpha;\n\nvoid main(void){\n\n  vec3 sky = texture2D(tSkyColor, vec2(vView.x, vView.y)).rgb;\n  \n  gl_FragColor = vec4(sky, uAlpha);\n}';
return __p;
};
fn.toString=fn;
module.exports = fn;